<template>
    <button class="heading__logout" @click.prevent="clickLogout">
        <span class="heading__logout_text">
            Logout
        </span>
    </button>
</template>

<script>

export default {
    name: "modal_logout",
    props: {},
    emits: ['click_logout'],
    components: {},
    mixins: [],
    data() {
        return {}
    },
    methods: {
        clickLogout() {
            this.$emit('click_logout');
        }
    },
    computed: {},
    watch: {}
}
</script>
